import {IActionModel} from "../../shared/models/action.model";
import {CLEAR_PREVIOUS_ROUTE, SET_CURRENT_ROUTE, SET_QUERY_PARAMS_DATA} from "../actions/stateManagement.action";
import {CommonService} from "../../shared/services";
import {Misc} from "../../constants";

export interface IStateManagementState {
    queryParamData: any;
    currentRoute?: string;
    referer?: string;
    history?: {
        [url: string]: {
            previousRoute: string;
        }
    }
}

const navigationHistory = CommonService._localStorage.getItem(Misc.NAVIGATION_HISTORY);

const INITIAL_STATE: IStateManagementState = {
    queryParamData: undefined,
    currentRoute: CommonService._localStorage.getItem(Misc.CURRENT_ROUTE) || '',
    history: navigationHistory ? JSON.parse(navigationHistory) : {},
};

const stateManagementReducer = (state: IStateManagementState = INITIAL_STATE, action: IActionModel): IStateManagementState => {
    switch (action.type) {
        case SET_QUERY_PARAMS_DATA:
            state.queryParamData = action.payload;
            return {
                ...state,
            };
        case SET_CURRENT_ROUTE:
            const currentRoute = action.payload.currentRoute;
            const overridePrevRoute = action.payload.overridePrevRoute;
            if (action.payload.currentRoute === state.currentRoute) {
                return state;
            }
            if (overridePrevRoute) {
                if (state.currentRoute && state.history) {
                    if (!state.history[currentRoute]?.previousRoute) {
                        state.history[currentRoute] = {
                            previousRoute: state.currentRoute
                        };
                    }
                }
            }
            CommonService._localStorage.setItem(Misc.CURRENT_ROUTE, currentRoute);
            CommonService._localStorage.setItem(Misc.NAVIGATION_HISTORY, JSON.stringify(state.history));
            state.currentRoute = currentRoute;
            return {
                ...state,
            };
        case CLEAR_PREVIOUS_ROUTE:
            const currRoute = state.currentRoute;
            if (currRoute && state.history && state.history[currRoute]) {
                delete state.history[currRoute];
            }
            return {
                ...state,
                history: state.history
            }
        default:
            return state;
    }
};

export default stateManagementReducer;

